import React from "react"



export default function Card(props) {
    let badgeText
    if (props.item.openSpots === 0) {
        badgeText = "SOLD OUT"
    } else if (props.item.location === "Online") {
        badgeText = "ONLINE"
    }



    
    return (
        <div className="card"  >
<a href={`/${props.item.route}`} target="_blank" rel="noopener noreferrer" >
            <img src={props.item.coverImg} className="card--image" />
        
            <div className="card--title">{props.item.title}</div>
            </a>
        </div>
    )
}